import { MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit'
import React, { forwardRef, useState } from 'react'
import { useNavigate } from 'react-router';
import { deleteStreamsTeam } from '../../../apiclients/streamsapi_bridge';
import { useTranslation } from 'react-i18next';

const RemoveStreamsTeam = forwardRef((props, ref) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  //const [isloading, setIsloading] = useState(false);

  async function removeThisTeam(e) {
    console.log(props.teamId);
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    props.setIsloading(true);
    let deleteUSer = await deleteStreamsTeam(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      props.teamId
    );
    setTimeout(() => {
      props.setIsloading(false);
    }, 1000);
    let deleteMsg = await deleteUSer.json();
    console.log("Response... " + deleteMsg);
    console.log(deleteMsg);
    if (deleteMsg.status == "Failed") {
      localStorage.setItem(
        "user_create_f",
        "Something went wrong, Please try again after sometime"
      );
      props.onClose();
      window.location.href = "/streamsteamssection";
    } else {
      props.onClose();
      localStorage.setItem("s_message", deleteMsg.message);
      window.location.href = "/streamsteamssection";
    }
  }

  return (
    <>
      {/* {isloading && (
      <>
        <div className="loadingclass">
          <MDBBtn disabled>
            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
            Loading...
          </MDBBtn>
        </div>
      </>
    )} */}

      <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
        <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
        <span>{t("RemoveStreamTeamtxt")}</span>
      </div>


      <div style={{ display: "none" }}>
        <button ref={ref} onClick={(e) => removeThisTeam(e)}>
          {t("remove")}</button>
      </div>

      {/* <MDBModalFooter>
      <MDBBtn color="secondary" onClick={props.onClose}>
        {t("cancel")}
      </MDBBtn>
      <MDBBtn onClick={(e) => removeThisTeam(e)}>{t("remove")}</MDBBtn>
    </MDBModalFooter> */}
    </>
  )
});

export default RemoveStreamsTeam
